import { ALL_TIME_ZONES } from '@/modules/events/utilities';
import { TIMEZONE_GUESS } from '@/utilities';

export const useTimezone = (
  eventTimezone?: string,
  showBrowserTimezone?: boolean
) => {
  const rawTimezone = eventTimezone || TIMEZONE_GUESS;

  const currentTimeZoneLabel =
    (ALL_TIME_ZONES.filter((timezone) => timezone.zone === rawTimezone)
      ?.length &&
      ALL_TIME_ZONES.filter((timezone) => timezone.zone === rawTimezone)[0]
        ?.label) ||
    eventTimezone;

  const browserTimeZoneLabel =
    (ALL_TIME_ZONES.filter((timezone) => timezone.zone === TIMEZONE_GUESS)
      .length &&
      ALL_TIME_ZONES.filter((timezone) => timezone.zone === TIMEZONE_GUESS)[0]
        ?.label) ||
    eventTimezone;

  const readableTimezone = showBrowserTimezone
    ? `${` (${browserTimeZoneLabel})`}`
    : eventTimezone
    ? ` (${currentTimeZoneLabel})`
    : '';

  return {
    rawTimezone, // ex: "America/Los_Angeles"
    readableTimezone, // ex: " (Pacific Time)"
  };
};
